<template>
  <v-form>
    <v-textarea
      v-model.trim="observacoes"
      auto-grow
      auto-focus
      counter
      :counter-value="() => observacoes.length"
      solo
      maxlength="500"
      class="mt-3"
      data-cy="reembolso_observacoes"
      :placeholder="placeholder"
      :row-height="54"
      :rows="5"
      :error-messages="errorObservacoes"
    />

    <v-file-input
      v-model="anexos"
      data-cy="reembolso_anexos"
      multiple
      solo
      flat
      height="56px"
      accept="image/jpeg, image/png, application/pdf"
      label="Insira até 3 imagens"
      :show-size="1000"
      :counter="3"
      :error-messages="errorAnexosMessages"
      :error="errorAnexos"
      prepend-icon=""
      class="my-3"
    >
      <template v-slot:label>
        <v-icon>mdi-paperclip</v-icon>
        Insira até 3 imagens
      </template>
    </v-file-input>
    <div
      :class="$vuetify.breakpoint.mdAndUp
        ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile botoes-rodape--stepper'"
      class="botoes-rodape --reembolso pa-3 pa-md-0 px-md-0"
    >
      <BtnVoltar />
      <v-btn
        color="primary"
        :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
        data-cy="btn_enviar"
        :disabled="desabilitarBtn"
        :loading="botaoLoading"
        @click="enviarDescricaoMotivo"
      >
        Enviar
      </v-btn>
    </div>
  </v-form>
</template>

<script>

import { required, minLength } from 'vuelidate/lib/validators';
import BtnVoltar from '@/components/Steppers/BtnVoltar.vue';
import api from '@/api';

export default {

  name: 'FormDescricaoMotivo',

  components: {
    BtnVoltar,
  },

  props: {
    codigoVenda: {
      type: Number,
      required: true,
    },

    codigoReembolso: {
      type: Number,
      required: true,
    },

    urlEnvio: {
      type: String,
      required: true,
    },

    observacaoObrigatorio: {
      type: Boolean,
      required: false,
      default: false,
    },

    codigoMotivo: {
      type: Number,
      required: false,
      default: 0,
    },

  },

  data: () => ({
    observacoes: '',
    placeholder: 'Observações',
    anexos: [],
    invalidObservacoes: ['Por favor, preencha pelo menos 25 caracteres.'],
    errorAnexosMessages: [],
    errorAnexos: false,
    desabilitarBtn: true,
    botaoLoading: false,
  }),

  computed: {
    errorObservacoes() {
      let errors = [];
      if (this.$v.observacoes.$dirty && this.$v.observacoes.$invalid) {
        errors = this.invalidObservacoes;
      }

      return errors;
    },

    rules() {
      const rules = {
        observacoes: {
          minLength: minLength(25),
        },
      };

      if (this.observacaoObrigatorio) {
        rules.observacoes.required = required;
      }

      return rules;
    },
  },

  watch: {
    observacoes() {
      this.$v.observacoes.$touch();
      this.checarDados();
    },

    anexos() {
      this.validacaoInputFile();
      this.checarDados();
    },
  },

  methods: {
    validacaoInputFile() {
      const arquivos = this.anexos;

      if (!arquivos) {
        return;
      }

      const errorMessages = [];

      if (arquivos.length > 3) {
        errorMessages.push('Por favor, insira no máximo 3 imagens.');
      }

      if (arquivos.some(file => file.size > 5000000)) {
        errorMessages.push('Por favor, insira arquivos de no máximo 5MB.');
      }

      const extensoesAceitas = ['jpg', 'jpeg', 'png', 'pdf'];
      const extensaoAceita = arquivos.every((file) => {
        const partesArquivo = file.name.split('.');
        const extensao = partesArquivo[partesArquivo.length - 1].toLowerCase();
        return extensoesAceitas.includes(extensao);
      });

      if (arquivos.length && !extensaoAceita) {
        errorMessages.push('Por favor, insira arquivos com as extensões: jpg, jpeg, png ou pdf.');
      }

      this.errorAnexosMessages = errorMessages;
      this.errorAnexos = errorMessages.length > 0;
    },

    checarDados() {
      const anexoValido = !this.errorAnexos;
      const observacoesValido = !this.$v.observacoes.$invalid;

      let formValido = observacoesValido && anexoValido;
      if (!this.observacaoObrigatorio) {
        formValido = formValido && (this.observacoes !== '' || this.anexos.length);
      }

      this.desabilitarBtn = !formValido;
    },

    async enviarDescricaoMotivo() {
      this.botaoLoading = true;

      const formdata = new FormData();
      formdata.append('order', this.codigoVenda);
      formdata.append('refund_request_id', this.codigoReembolso);
      formdata.append('category', this.codigoMotivo);
      formdata.append('comments', this.observacoes);
      formdata.append('product_sent', '1');

      for (let i = 0; i < this.anexos.length; i++) {
        formdata.append(`file${i}`, this.anexos[i]);
      }

      let sucesso = true;

      try {
        await api.post(this.urlEnvio, formdata);
      } catch (error) {
        sucesso = false;
      }

      this.$emit('respostaApi', sucesso);
    },
  },

  validations() {
    return this.rules;
  },

};
</script>

<style lang="scss">
  .v-input .v-label{
    height: 23px;
  }
</style>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';
</style>
